module.exports = __webpack_public_path__ + "img/footer_bg.5a64161.png";